/* eslint-disable no-restricted-syntax */
import React, { useState, useEffect, useRef, useContext } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Fragment } from 'react';

import globalContext from '../../../context/GlobalContext';
import DailyRecommendationSkeleton from './skeleton/DailyRecommendationSkeleton';
import DynamicDialog from './DynamicDialog';

import RecommendationDetails from './RecommendationDetails';
import RecommendationCard from './RecommendationCard';
import RecommendationUnsupportedDevice from './RecommendationUnsupportedDevice';
import RecommendationEmptyState from './RecommendationEmptyState';
import RecommendationAccess from '../../../dataAccess/RecommendationAccess';
import { setUserProfile } from '../../../redux/actions/userProfileAction';
import {
  emptyRecommendation, groupBy, cleanAndUpdateUnitArrayData, overlayTopSide, parseSqlArray, unOverlayTopSide
} from '../../../utilities/utils';
import { compareDates, getShiftedApiDateMMDDYYYY, getShiftedApiDateYYYYMMDD } from '../../../utilities/dates';
import { Body3400C  } from '../../../utilities/generatedClasses';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@mui/material';
import { useSearchParams } from 'react-router-dom';


const DailyView = () => {
  const [dailyRecommendations, setDailyRecommendations] = useState(null);
  const [windowWidth, setWidth] = useState(0);
  const [skeleton, setSkeleton] = useState(false);
  const [selectedRecommendation, setSelectedRecommendation] = useState(null);
  const [isDynamicDialogOpen, setDynamicDialogOpen] = React.useState(false);
  const [selectedDateIndex, setSelectedeDateIndex] = React.useState(-1);
  const [otherData, setOtherData] = React.useState(null);
  const contextcache = useSelector(state => state.context);
  const selectedSevenDays = useSelector(state => state.selectedSevenDays);
  const topFilterData = useSelector(state => state.widgetFiltes);
  const context = useContext(globalContext);


    const [dialogData, setDialogData] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

   const [searchParams] = useSearchParams();

    const clientId = searchParams.get("clientid");
  const getQtyDescrptrQtyUnitIdArray = (qtyDescrptr) => {
    try {
      qtyDescrptr = parseSqlArray(qtyDescrptr);
      if(qtyDescrptr && qtyDescrptr[0] && qtyDescrptr[0].QtyDescrptr === "HourMinuteQty"){
        let timeValue = qtyDescrptr[0].Qty.split(':')
        let _qtyDescrptr = [
         { 'QtyDescrptr': 'Hours', 'Qty': timeValue[0], 'Unit': 'hr', 'UnitId': '949' }, { 'QtyDescrptr': 'Minutes', 'Qty': timeValue[1], 'Unit': 'min', 'UnitId': '949'  }
        ]

        qtyDescrptr = _qtyDescrptr;
      } else {
        qtyDescrptr.forEach((element) => {
          const unit = contextcache.units.find(x => x.UnitID === element.UnitId);
          if (unit) {
            element.Unit = unit.UnitAbrvName;
          }
        });
      }
      return qtyDescrptr;
    } catch (ex) {
      return null;
    }
  };
  
  function getTopDateByCount(array, dateProperty) {
    const groupedByDate = array.reduce((acc, obj) => {
      const date = obj[dateProperty];
      acc[date] = (acc[date] || 0) + 1;
      return acc;
    }, {});

    let maxCount = 0;

    for (const date in groupedByDate) {
      if (groupedByDate[date] > maxCount) {
        maxCount = groupedByDate[date];
      }
    }

    return maxCount;
  }

  const loadData = (res) => {
    if (selectedSevenDays && selectedSevenDays.length > 0) {
      const groupedByMeasures = groupBy(res, section => section.MeasureId);
      const itemsByMeasure = Array.from(groupedByMeasures, ([measureId, data]) => ({ measureId, data }));
      const dailyRecommendationsCloned = [];
      for (let i = 0; i < itemsByMeasure.length; i += 1) {
        for (let j = 0; j < selectedSevenDays.length; j += 1) {
          if (selectedDateIndex === -1 && compareDates(selectedSevenDays[j].Date, topFilterData.selectedDate)) {
            setSelectedeDateIndex(j);
          }
          let day = getShiftedApiDateYYYYMMDD(selectedSevenDays[j].Date);
          const itemExist = itemsByMeasure[i].data.filter(y => y.RcmndtnOccurncDate === day);
          if (itemExist.length > 0) {
            itemExist.forEach((el) => {
              dailyRecommendationsCloned.push(el);
            });
          } else {
            const countByDate = getTopDateByCount(itemsByMeasure[i].data, 'RcmndtnOccurncDate');
            let _measure = contextcache.measurements.find(x => x.MeasureId === itemsByMeasure[i].measureId);
            for (let b = 0; b < countByDate; b++) {

              dailyRecommendationsCloned.push(emptyRecommendation(day, itemsByMeasure[i].measureId, _measure, itemsByMeasure[i].data[0]));
            }
          }
        }
      }

      const groupedByDates = groupBy(dailyRecommendationsCloned, section => section.RcmndtnOccurncDate);
      const fetchedRecommendations = Array.from(groupedByDates, ([selectedDate, data]) => ({ selectedDate, data }));
      // Reorder
      const sortedMeasurements = [...contextcache.measurements].sort(
            (a, b) => Number(a.MeasureCtgySortOrdr) - Number(b.MeasureCtgySortOrdr)
          );

          const measureCtgyLookup = new Map(
            sortedMeasurements.map(m => [String(m.MeasureId), m.MeasureCtgyId])
          );

          const measureCtgyLookupObj = Object.fromEntries(measureCtgyLookup);
          const ctgyOrder = new Map();
          sortedMeasurements.forEach((m, idx) => {
            if (!ctgyOrder.has(m.MeasureCtgyId)) ctgyOrder.set(m.MeasureCtgyId, idx);
          });

          fetchedRecommendations.forEach(recommendations => {
              recommendations.data.sort((x, y) => {
                const aCtgy = measureCtgyLookup.get(String(x.MeasureId)) ?? measureCtgyLookupObj[x.MeasureId];
                const bCtgy = measureCtgyLookup.get(String(y.MeasureId)) ?? measureCtgyLookupObj[y.MeasureId];

                const aOrder = ctgyOrder.has(aCtgy) ? ctgyOrder.get(aCtgy) : Number.POSITIVE_INFINITY;
                const bOrder = ctgyOrder.has(bCtgy) ? ctgyOrder.get(bCtgy) : Number.POSITIVE_INFINITY;

                // tie-breaker: keep stable by using MeasureId if same category
                if (aOrder === bOrder) return String(x.MeasureId).localeCompare(String(y.MeasureId), undefined, {numeric: true});
                return aOrder - bOrder;
              }); 
          });
        


      setDailyRecommendations(fetchedRecommendations);
      setSkeleton(true);
    }
  };

  // Get Recommendations for selected seven days
  const fetchRecommendations = () => {
    let startDate = getShiftedApiDateMMDDYYYY(selectedSevenDays[0].Date);
    let endDate = getShiftedApiDateMMDDYYYY(selectedSevenDays[6].Date);

    RecommendationAccess.getRecommendationsCalendar(startDate, endDate, clientId)
      .then((response) => {
        if (response.status === 204) {
          return;
        }
        const fetchedRecommendations = [];

        const selectedMeasures = contextcache.measurements.filter(x => topFilterData.widgetFiltes.includes(x.VisualTypeOne));
        response.data.forEach((data) => {
          const selectedMeasure = selectedMeasures.find(x => x.MeasureId === data.MeasureId);
          if (selectedMeasure) {
            data.selectedMeasure = selectedMeasure;
            data.PrcsParmtrValueOne = selectedMeasure.MeasureName;
            data.QtyDescrptr_Qty_UnitIdArray = getQtyDescrptrQtyUnitIdArray(data.QtyDescrptr_Qty_UnitIdArray);
            fetchedRecommendations.push(data);
          }
        });

        loadData(fetchedRecommendations);
      }).catch((err) => {
        setSkeleton(true);
        context.navigation.push('/maintenance');
      });
  };


  function getWindowDimensions() {
    setWidth(window.innerWidth);
  }



  // Open Recommendation Card details
  const showRecommendationDetails = (dataIndex, index) => {
    const selectedItem = dailyRecommendations[dataIndex].data[index];
    // if (!selectedItem.isHidden) {
    if (selectedItem.isDeleted) restoreOccurence(selectedItem.RcmndtnOccurncId);

    else if (selectedItem && selectedRecommendation
                && selectedItem.RcmndtnOccurncId === selectedRecommendation.RcmndtnOccurncId) setSelectedRecommendation(null);

    else setSelectedRecommendation(selectedItem);
    // }
  };

  // Edit Series Call
  const editSeries = (data) => {
    setSkeleton(false);

    let _data = {}
    if(data && data.QtyDescrptr_Qty_UnitIdArray_HrMin && data.QtyDescrptr_Qty_UnitIdArray_HrMin.length === 2){
    _data = {
        Row: 1,
        MeasureId: data.MeasureId,
        Qty: data.QtyDescrptr_Qty_UnitIdArray_HrMin.map((item, index) => ({
          QtyDescrptr: index == 0  ? "Hours" : "Minutes",
          Qty: data.QtyDescrptr_Qty_UnitIdArray_HrMin[index].Qty
        })),
        UnitId: data.QtyDescrptr_Qty_UnitIdArray[0].UnitId,
        DayOfWeekFreqcy: data.DayOfWeekFreqcy.join(","),
        StartDate: data.StartDate,
        EndDate: data.EndDate,
      };
    } else {
    _data = {
        Row: 1,
        MeasureId: data.MeasureId,
        Qty: data.QtyDescrptr_Qty_UnitIdArray.map(item => ({
          QtyDescrptr: item.QtyDescrptr,
          Qty: item.Qty
        })),
        UnitId: data.QtyDescrptr_Qty_UnitIdArray[0].UnitId,
        DayOfWeekFreqcy: data.DayOfWeekFreqcy.join(","),
        StartDate: data.StartDate,
        EndDate: data.EndDate,
      };
    }
  
    var formattedString =
    "[{" +
    Object.entries(_data)
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          return `"${key}":${JSON.stringify(value)}`;
        }
        return `"${key}":"${value}"`;
      })
      .join(",") +
    "}]";

    formattedString = formattedString.replace(/"/g, "''")
    
    RecommendationAccess.editSeries(clientId, data.Id, formattedString)
      .then(() => fetchRecommendations())
      .catch(err => console.log(err));
  };

  // Edit Occurence Call
  const editOccurrence = (data) => {
    setSkeleton(false);
   let _data = {}
     if(data && data.QtyDescrptr_Qty_UnitIdArray_HrMin && data.QtyDescrptr_Qty_UnitIdArray_HrMin.length === 2){
      _data = {
        Row: 1,
        MeasureId: data.MeasureId,
      Qty: data.QtyDescrptr_Qty_UnitIdArray_HrMin.map((item, index) => ({
          QtyDescrptr: index == 0  ? "Hours" : "Minutes",
          Qty: data.QtyDescrptr_Qty_UnitIdArray_HrMin[index].Qty
        })),
        UnitId: data.QtyDescrptr_Qty_UnitIdArray[0].UnitId,
        DayOfWeekFreqcy: data.DayOfWeekFreqcy.join(","),
        StartDate: data.StartDate,
        EndDate: data.EndDate,
      };
    } else {
      _data = {
        Row: '1',
        MeasureId: data.MeasureId,
        Qty: data.QtyDescrptr_Qty_UnitIdArray.map(item => ({
          QtyDescrptr: item.QtyDescrptr,
          Qty: item.Qty
        })),
        UnitId: data.QtyDescrptr_Qty_UnitIdArray[0].UnitId,
        DayOfWeekFreqcy: data.DayOfWeekFreqcy.join(","),
        StartDate: data.StartDate,
        EndDate: data.EndDate,
      }
    }
   
    
    var formattedString =
    "[{" +
    Object.entries(_data)
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          return `"${key}":${JSON.stringify(value)}`;
        }
        return `"${key}":"${value}"`;
      })
      .join(",") +
    "}]";

    formattedString = formattedString.replace(/"/g, "''")
    formattedString = formattedString.replace(/''/g, "''")


    RecommendationAccess.editOccurence(clientId, data.Id, formattedString)
      .then(() => fetchRecommendations())
      .catch(err => console.log(err));
  };

  const handleDynamicClose = (type, values) => {
    switch (type) {
      case 'EditSeries':
        editSeries(values);
        break;

      case 'EditOccurence':
        editOccurrence(values);
        break;

      default:
        setSkeleton(true);
        break;
    }
    unOverlayTopSide();
    setDynamicDialogOpen(false);
  };

  const removeSelectedRecommendation = (e) => {
    if (e.target.classList.contains('Out_Rec_Card')) setSelectedRecommendation(null);
  };
  // Open Dynamic Dialog
  const openEditSeriesDialog = (recDetails) => {
    overlayTopSide();
    const selectedMeasure = contextcache.measurements.find(x => x.MeasureId === selectedRecommendation.MeasureId);
    setDynamicDialogOpen(true);
    setOtherData({
      type: 'EditSeries',
      measure: selectedMeasure,
      recommendation: recDetails,
      selectedRecommendation: selectedRecommendation,
      unitArrays: cleanAndUpdateUnitArrayData(selectedMeasure.UnitArray, contextcache.units),
      QtyDescrptr_Qty_UnitIdArray_OldValue: null
    });
  };


  // Open Dynamic Dialog
  const openEditOccurenceDialog = (recDetails) => {
    const selectedMeasure = contextcache.measurements.find(x => x.MeasureId == selectedRecommendation.MeasureId);
     overlayTopSide();
     setDynamicDialogOpen(true);
     setOtherData({
      type: "EditOccurence",
      measure: selectedMeasure,
      recommendation: recDetails,
      selectedRecommendation: selectedRecommendation,
      unitArrays: cleanAndUpdateUnitArrayData(selectedMeasure.UnitArray, contextcache.units),
      QtyDescrptr_Qty_UnitIdArray_OldValue: null
     })
  };

  const handleClose = () => {
    setIsDialogOpen(false);
    setDialogData(null);

  };

  const handleConfirm = () => {
    setSkeleton(false);

    if(dialogData.type === 'RemoveOccurence') {
          RecommendationAccess.deleteOccurence(clientId, dialogData.recommendationOccurenceId)
            .then(() => fetchRecommendations());
    }
    else if(dialogData.type === 'RemoveSeries') {
          RecommendationAccess.deleteSeries(clientId, dialogData.recommendationSeriesId)
            .then(() => fetchRecommendations());
        }
    else if(dialogData.type === 'RestoreOccurence') {
          RecommendationAccess.restoreOccurence(clientId, dialogData.recommendationOccurenceId)
            .then(() => fetchRecommendations());
        }
    setIsDialogOpen(false);
    setDialogData(null);
  };

  const restoreOccurence = (recommendationOccurenceId) => {
    setDialogData({
      title: 'Restore Occurence',
      message: 'Are you sure you want to restore Occurence?',
      confirmText: 'Restore',
      type: 'RestoreOccurence',
      recommendationOccurenceId
    });
    setIsDialogOpen(true);

  };

  const deleteOccurence = (recommendationOccurenceId) => {
    setDialogData({
      title: 'Remove Occurence',
      message: 'Are you sure you want to remove Occurence?',
      confirmText: 'Remove',
      type: 'RemoveOccurence',
      recommendationOccurenceId
    });
    setIsDialogOpen(true);
  };

  const deleteSeries = (recommendationSeriesId) => {
    setDialogData({
      title: 'Remove Series',
      message: 'Are you sure you want to remove Series?',
      confirmText: 'Remove',
      type: 'RemoveSeries',
      recommendationSeriesId
    });
    setIsDialogOpen(true);
  };

  const fetchKeyRef = useRef(null);
  useEffect(() => {
    if (!contextcache || selectedSevenDays.length === 0 || topFilterData.widgetFiltes.length === 0) return;

    const fetchKey = `${selectedSevenDays[0]?.Date}_${selectedSevenDays[6]?.Date}_${topFilterData.widgetFiltes.join(',')}_${topFilterData.selectedDate}`;
    if (fetchKeyRef.current === fetchKey) return;
    fetchKeyRef.current = fetchKey;

    setSelectedeDateIndex(-1);
    fetchRecommendations();
  }, [contextcache, selectedSevenDays, topFilterData]);

  useEffect(() => {
    getWindowDimensions();
    window.addEventListener('resize', getWindowDimensions);
    return () => window.removeEventListener('resize', getWindowDimensions);
  }, []);

  const dispatch = useDispatch();
  const openUserProfile = (data) => {
    if(data.RcmndtnOccurncId !== "99999999999999999"){
      setTimeout(() => {
        setSelectedRecommendation(null);
      }, 50);
      dispatch(setUserProfile(data.ProviderId));
    }
    
  };

  return (
    <>
      <div onClick={removeSelectedRecommendation} className="Out_Rec_Card" aria-hidden="true">
        {/* <DailyRecommendationSkeleton /> */}
        {!skeleton && <DailyRecommendationSkeleton />}

        <div className="recommendations-container Out_Rec_Card">
{
  skeleton && windowWidth && windowWidth > 300 && dailyRecommendations.length > 0 &&
  <>
   <span className={`week-header-main-row-left-arrow `}  />
      <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', margin: '1.4vw', marginTop: 0, position: 'relative'}}>
  { dailyRecommendations.map((selectedDate, dataIndex) => (
            <Fragment key={dataIndex}>
              <div className={`grid_item Out_Rec_Card ${dataIndex === selectedDateIndex ? 'blue-line' : ''}`}>
                {selectedDate.data.map((data, index) => (
                  <div
                    className="card_height recommendation-height-auto"
                    key={index}>
                    <RecommendationCard
                      data={data}
                      index={index}
                      dataIndex={dataIndex}
                      showRecommendation={showRecommendationDetails}
                      windowWidth={windowWidth}
                      openUserProfile={openUserProfile}
                      />

                    {
                        selectedRecommendation && selectedRecommendation.RcmndtnOccurncId === data.RcmndtnOccurncId && !selectedRecommendation.isHidden
                            && (
                            <RecommendationDetails
                              data={data}
                              dataIndex={dataIndex}
                              windowWidth={windowWidth}
                              selectedItem={selectedRecommendation}
                              openEditOccurenceDialog={openEditOccurenceDialog}
                              openEditSeriesDialog={openEditSeriesDialog}
                              deleteOccurence={deleteOccurence}
                              deleteSeries={deleteSeries}
                            />
                            )

                        }
                  </div>
                ))}
              </div>

              {dataIndex !== dailyRecommendations.length - 1
              && <hr className="grid_item_border Out_Rec_Card" />
            }
            </Fragment>
          ))}
      </div>
        
              <span className={`week-header-main-row-left-arrow`}    aria-hidden />
  <div className="week-header-main-picker-year week-header-main-picker-year-hidden  custom-space-between" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <div className="week-header-main-picker-year"  aria-hidden>
                <div
                  className={`week-header-main-picker-year-calendar `}
                   />
              </div>
              <div className="year-date">
                <span className={`week-header-main-picker-year-text ${Body3400C}`} style={{ opacity: 0}}>2025</span>
              </div>
              <div className="week-header-main-picker-year" >
                <div id="calendarIconButton" className={`week-header-main-picker-year-calendar `} />
              </div>
            </div>
  </>
}
             

          {windowWidth && windowWidth < 300 && dailyRecommendations && dailyRecommendations.length > 0
          && <RecommendationUnsupportedDevice />
          }

          {skeleton && dailyRecommendations && dailyRecommendations.length === 0
          && <RecommendationEmptyState />
        }

          <DynamicDialog
            open={isDynamicDialogOpen}
            onClose={handleDynamicClose}
            data={otherData}
          />
        </div>
      </div>
      {dialogData && (
            <Dialog
              open={isDialogOpen}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {dialogData.title}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {dialogData.message}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleConfirm} autoFocus>
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>)}
    </>


  );
};
export default DailyView;
